import { useTranslation } from 'react-i18next';
import type { CreateApiTokenResponseDto } from '../model';
import { CopyField } from '@/shared/components';
import { useAppSettingsDictionary } from '@/shared/api';

type Props = {
  apiToken: CreateApiTokenResponseDto;
};

const CreateApiTokenResultDetails = ({ apiToken }: Props) => {
  const { t } = useTranslation();
  const { appSettingsData } = useAppSettingsDictionary();

  const accessLabels: Record<string, string> = Object.assign(
    {},
    ...(appSettingsData?.value.tradingWebapiTokenAccessList ?? [])
  );
  const accessLabel = accessLabels[apiToken.access] ?? apiToken.access;

  return (
    <div className="flex flex-col gap-[2.4rem] px-[2.4rem] py-[1.6rem] bg-secondary-bg rounded-[1.6rem] mb-[2.4rem] sm:mb-[3.2rem] w-full">
      <div className="flex flex-col gap-[0.2rem]">
        <label className="p4 text-muted-foreground">
          {t('webApiTokens.fieldLabels.id')}:
        </label>
        <CopyField value={apiToken.webapiTokenid} variant="compact" />
      </div>

      <div className="flex flex-col gap-[0.2rem]">
        <label className="p4 text-muted-foreground">
          {t('webApiTokens.fieldLabels.key')}:
        </label>
        <CopyField value={apiToken.key} variant="compact" />
      </div>

      <div className="flex flex-col gap-[0.2rem]">
        <label className="p4 text-muted-foreground">
          {t('webApiTokens.fieldLabels.secret')}:
        </label>
        <CopyField value={apiToken.secret} variant="compact" />
      </div>

      <div className="flex gap-[1.6rem] items-start">
        <div className="flex flex-col gap-[0.2rem] flex-1">
          <label className="p4 text-muted-foreground">
            {t('webApiTokens.fieldLabels.authenticationType')}:
          </label>

          <span className="headline4 text-primary break-all">
            {apiToken.authenticationType}
          </span>
        </div>

        <div className="flex flex-col gap-[0.2rem] flex-1">
          <label className="p4 text-muted-foreground">
            {t('webApiTokens.fieldLabels.accessRights')}:
          </label>

          <span className="headline4 text-primary break-all">
            {accessLabel}
          </span>
        </div>
      </div>
    </div>
  );
};

export { CreateApiTokenResultDetails };
